module.exports = __webpack_public_path__ + "img/testimonial-image@2x.adc67ac4.png";